import React from 'react'
import { Bar, BarChart, Cell, LabelList, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'
import ChartTooltip, { BarLabel } from './ChartTooltip'
import { ACTIVE_BAR } from './DailyChart'
import useChartColors from './useChartColors'

const ROW_HEIGHT = 30

// Rótulo da categoria: texto longo (título digitado no prontuário) é cortado, e o inteiro fica no title e na tabela
const CategoryTick = ({ x, y, payload, labels, maxChars }) => {
  const { chart: colors } = useChartColors()
  const label = labels[payload?.value] || ''
  const text = (label.length > maxChars) ? `${label.slice(0, maxChars - 1)}…` : label
  return (
    <text x={x} y={y} dy={4} textAnchor='end' fill={colors.ink} fontSize={12}>
      <title>{label}</title>
      {text}
    </text>
  )
}

// Barras horizontais com o valor na ponta (motivos, cidades, bairros). Uma série: todas na cor principal; "Outros" em cinza.
// O recharts 2.12.7 não navega pelo teclado no layout vertical: a leitura sem mouse fica pelo Ver tabela
const RankingChart = ({ rows, tooltipFor, labelWidth = 150, valueWidth = 72 }) => {
  const { chart: colors } = useChartColors()
  const labels = Object.fromEntries(rows.map((row) => [row.key, row.label]))

  return (
    <ResponsiveContainer width='100%' height={(rows.length * ROW_HEIGHT) + 8}>
      <BarChart data={rows} layout='vertical' margin={{ top: 4, right: valueWidth, bottom: 4, left: 0 }} barCategoryGap='28%'>
        <XAxis type='number' hide domain={[0, 'dataMax']} />
        <YAxis
          type='category'
          dataKey='key'
          width={labelWidth}
          interval={0}
          tickLine={false}
          axisLine={false}
          tick={<CategoryTick labels={labels} maxChars={Math.floor(labelWidth / 7)} />}
        />
        <Tooltip cursor={{ fill: colors.cursor }} content={<ChartTooltip render={tooltipFor} />} isAnimationActive={false} />
        <Bar dataKey='value' radius={[0, 4, 4, 0]} maxBarSize={16} activeBar={ACTIVE_BAR} isAnimationActive={false}>
          {rows.map((row) => <Cell key={row.key} fill={row.muted ? colors.others : colors.primary} />)}
          <LabelList dataKey='valueText' content={<BarLabel placement='right' />} />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  )
}

export default RankingChart
